var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarouselIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 288 288",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 288,
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "color000 svgShape",
    transform: "matrix(.1 0 0 -.1 0 200)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    className: "color000 svgShape",
    d: "m542 1588c-17-17-17-1159 0-1176s899-17 916 0 17 1159 0 1176-899 17-916 0zm858-588v-530h-400-400v530 530h400 400v-530zm-1264 515c-3-9-6-243-6-520 0-535 0-532 47-523 17 3 18 31 18 528v525l-26 3c-17 2-29-3-33-13zm141 8c-4-3-7-240-7-525 0-467 2-519 16-525 20-7 171 65 179 86 3 8-1 21-10 30-13 14-19 13-60-7-25-12-50-22-55-22-6 0-10 161-10 440s4 440 10 440c5 0 30-10 55-22 41-20 47-21 60-7 25 25 9 42-70 82-75 37-96 43-108 30zm1336-30c-78-40-93-58-68-82 13-14 19-13 60 7 25 12 50 22 55 22 6 0 10-161 10-440s-4-440-10-440c-5 0-30 10-55 22-41 20-47 21-60 7-9-9-13-22-10-30 8-21 159-93 179-86 15 6 16 56 14 529-3 604 9 553-115 491zm194 30c-4-3-7-240-7-525 0-471 2-519 16-525 9-3 24-2 33 4 14 9 16 63 19 509 1 274 0 509-3 522-5 21-42 31-58 15z",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarouselIcon);
export default __webpack_public_path__ + "static/media/carouselIcon.3f166c945b507811e8f3ef905501079c.svg";
export { ForwardRef as ReactComponent };